export interface IRebateSetting {
  id?: any;
  bankId?: any;
  commodityType?: string;
  name?: string;
  isActive?: boolean;
  rebateSchedule?: string | null;
  rebateLetterEnabled?: boolean | null;
  rebateLetterCategory?: string | null;
  rebateLetterLanguage?: string | null;
  rebateReportSettings?: string | null;
  rebateDocumentAttachSettings?: string | null;
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
}

export const defaultValue: Readonly<IRebateSetting> = {
  id: '',
  bankId: '',
  commodityType: '',
  name: '',
  isActive: true,
  rebateSchedule: null,
  rebateLetterEnabled: true,
  rebateLetterCategory: null,
  rebateLetterLanguage: null,
  rebateReportSettings: null,
  rebateDocumentAttachSettings: null,
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
};

export interface IRebateSettingCount {
  bankId?: any;
  internationalCount?: number;
  localCount?: number;
}
